import { render, staticRenderFns } from "./balance.vue?vue&type=template&id=61cefa9d&scoped=true&"
import script from "./balance.vue?vue&type=script&lang=js&"
export * from "./balance.vue?vue&type=script&lang=js&"
import style0 from "./balance.vue?vue&type=style&index=0&id=61cefa9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cefa9d",
  null
  
)

export default component.exports